<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Select period</h4>

  <button
    data-dd-action-name="select-period-modal.close-button"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('exit')"
  ></button>
</div>

@if (form) {
  <form [formGroup]="form" (validSubmit)="save() && modal.close()">
    <div class="modal-body">
      <app-form-control [columnLayout]="true" size="small">
        <app-form-label> Start date </app-form-label>

        <app-period-selector appValidationContext formControlName="startDate">
        </app-period-selector>
      </app-form-control>

      <app-form-control [columnLayout]="true" size="small">
        <app-form-label> End date </app-form-label>

        @if (!resetEndDate) {
          <app-period-selector
            appValidationContext
            formControlName="endDate"
            [minDate]="form.value.startDate"
            [useEndDate]="true"
          >
            <div *invalidMessageFor="'minDate'">
              End date must occur after the start date
            </div>
          </app-period-selector>
        }
      </app-form-control>

      @if (showMaxDateWarning) {
        <app-alert type="warning" size="small">
          <p>
            The latest end date you can select is the end of the next financial
            year:
            {{ maxEndDate | aadate }}
          </p>
        </app-alert>
      }
    </div>

    <div class="modal-footer">
      <button
        data-dd-action-name="select-period-modal.cancel-button"
        type="button"
        class="btn btn-outline"
        (click)="modal.dismiss()"
      >
        Cancel
      </button>
      <button
        data-dd-action-name="select-period-modal.save-button"
        type="submit"
        class="btn btn-primary ms-2"
        [disabled]="form.disabled"
      >
        <i-lucide name="save"></i-lucide>
        Save
      </button>
    </div>
  </form>
}
